module.exports = __webpack_public_path__ + "img/Necrophos.f606eeef.png";